import axiosClient from './axios-client';

export const getLeaderboard = () => {
  return axiosClient.get('/api/leaderboard');
};
